export * from './app-sidebar-nav.component';



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/components/app-sidebar-nav/index.ts